module.exports = __webpack_public_path__ + "static/media/menuNumber.581fe8e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuNumber.svg
// module id = 477
// module chunks = 0